import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import productForCartValidation from '../modules/Cart/utils/productForCartValidation';
import comboForCartValidation from '../modules/Cart/utils/comboForCartValidation';
import moment from 'moment';
import appConfig from '../../app-config';
import {
  PICKUP,
  DROPOFF,
  DELIVERY,
} from '../modules/OrderSetting/orderSettingTypes';
import { updateGlobalCart } from '../modules/Cart/cartActions';
const useCart = () => {
  const dispatch = useDispatch();
  const cartReducer = useSelector((state) => state.cartReducer); // cart from cartReducer
  const orderSettingReducer = useSelector((state) => state.orderSettingReducer);
  const dropOffLocationReducer = useSelector(
    (state) => state.dropOffLocationReducer
  );
  const { pickedDropOffLocation } = dropOffLocationReducer;
  const {
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
    interSelectedDateTime,
    selectedChild,
  } = orderSettingReducer;
  const { cart, products, combos, tipPercentage } = cartReducer;
  // C
  const [latestCart, setLatestCart] = useState(cart);
  // update local and store cart whenever any of callback dependency in app changes
  const cartUpdate = useCallback(() => {
    let cart = {
      tip: cartReducer.tipPercentage || 0,
      cart: [
        ...products.map((product) =>
          productForCartValidation(product.flatProduct)
        ),
        ...comboForCartValidation(combos || []),
      ],
      order_type: interOrderType,
    };
    // adding bussiness id
    if (appConfig.isParentChildClient && selectedChild) {
      cart.business_id = selectedChild.id;
    }
    if (interOrderType === PICKUP) {
      cart = {
        ...cart,
        business_id: interPickUpDetails?.id,
      };
    } else if (interOrderType === DELIVERY) {
      cart = {
        ...cart,
        customer_address_id: interDeliveryDetails?.id,
      };
      if (interDeliveryDetails && interDeliveryDetails.deliveryBusiness) {
        cart = {
          ...cart,
          business_id: interDeliveryDetails?.deliveryBusiness.id,
        };
      }
    } else {
      if (pickedDropOffLocation) {
        let dropOffLocation = [...pickedDropOffLocation];
        const dropOffLocationObject = dropOffLocation
          .reverse()
          .reduce((obj, selection) => {
            return {
              id: selection.id,
              option: { ...obj },
            };
          }, {});
        cart = {
          ...cart,
          drop_off_location: dropOffLocationObject,
          business_id: interDropOffDetails?.id,
        };
      }
    }
    if (interSelectedDateTime.radioValue.value === 'schedule') {
      let order_date = interSelectedDateTime.dateTime.date
        ? moment(
            interSelectedDateTime.dateTime.date.name +
              ' ' +
              interSelectedDateTime.dateTime.time.name,
            'ddd MMM DD h:mm A'
          ).format('YYYY-MM-DD HH:mm:ss')
        : null;
      cart = { ...cart, order_date: order_date };
    }
    setLatestCart(cart);
    dispatch(updateGlobalCart(cart));
  }, [
    products,
    combos,
    interOrderType,
    interSelectedDateTime,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
    dropOffLocationReducer,
    tipPercentage,
  ]);
  // callBack cartUpdate will be trigered if any of its dependencies changes
  useEffect(() => {
    cartUpdate();
  }, [cartUpdate]);
  return latestCart; // we have latest version of cart available both here and in cartReducer;
};
export default useCart;
